const isUndefined = (value: any): boolean => {
  return value === undefined
}

export default isUndefined
